import React from "react";
import { HiOutlinePhoto } from "react-icons/hi2";
import { useLanguage } from "../../../contexts/LanguageContext";

export function RecipeSelector({ recipes, loading, selectedRecipe, onSelect }) {
  const { t } = useLanguage();

  return (
    <div className="bg-slate-800/60 backdrop-blur rounded-xl border border-white/10 p-5">
      <label className="block text-sm font-medium text-white/90 mb-2">
        {t("selectRecipe")}
      </label>
      {loading ? (
        <p className="text-white/60 text-sm">{t("loadingRecipes")}</p>
      ) : recipes.length === 0 ? (
        <p className="text-white/60 text-sm">{t("noRecipesForPoster")}</p>
      ) : (
        <div className="space-y-1.5 max-h-44 overflow-y-auto">
          {recipes.map((rec) => (
            <button
              key={rec.id}
              type="button"
              onClick={() => onSelect(rec)}
              className={`w-full flex items-center gap-3 p-2.5 rounded-lg text-left transition-all ${
                selectedRecipe?.id === rec.id
                  ? "bg-orange-500/40 text-white"
                  : "bg-white/5 text-white/80 hover:bg-white/10"
              }`}
            >
              {rec.image_url || rec.image ? (
                <img
                  src={rec.image_url || rec.image}
                  alt=""
                  className="w-10 h-10 rounded-md object-cover shrink-0"
                />
              ) : (
                <div className="w-10 h-10 rounded-md bg-white/10 flex items-center justify-center shrink-0">
                  <HiOutlinePhoto className="w-5 h-5 text-white/50" />
                </div>
              )}
              <span className="text-sm font-medium truncate">
                {rec.title || "Sans titre"}
              </span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
